<div class="card card-custom">
  <div class="card-header">
    <div *ngIf="data.length > 1" class="card-title mr-0">
      <h3 class="card-label mr-0">
        <span class="label label-xl label-inline label-light-warning mr-3" style="width: 70px"
          >Before</span
        >{{ data[1].contact.first_name | titlecase }}
      </h3>
    </div>
    <div class="card-title mr-0">
      <h3 class="card-label mr-0">
        <span
          *ngIf="data.length > 1"
          class="label label-xl label-inline label-light-success mr-3"
          style="width: 70px"
          >After</span
        >{{ data[0].contact.first_name | titlecase }}
      </h3>
    </div>
  </div>
  <div
    class="card-body scrollTop p-0"
    style="overflow-x: hidden; padding: 23px !important"
    [ngClass]="{
      'justify-content-between': data.length > 1,
      'justify-content-center': data.length <= 1
    }"
  >
    <div class="row">
      <div [ngClass]="{ 'col-lg-6': data.length > 1 }">
        <kt-contact-add
          [fromHis]="true"
          *ngIf="data.length > 1"
          [idx]="1"
          style="padding: 25px"
        ></kt-contact-add>
      </div>
      <div [ngClass]="{ 'col-lg-6': data.length > 1 }">
        <kt-contact-add [fromHis]="true" [idx]="0" style="padding: 25px"></kt-contact-add>
      </div>
    </div>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button type="button" mat-raised-button (click)="close()">
      <span translate="GLOBAL.CLOSE">Close</span>
    </button>
  </div>
</div>
